import React from 'react';
import { Text } from '@chakra-ui/core';
import { QuestionnaireTemplateStore } from '../../../store/questionnaireTemplateModel';

export const QuestionNumber = React.memo(function QuestionNumber({ id }: { id: string }) {
  const index = QuestionnaireTemplateStore.useStoreState((s) => s.getElementIndex(id).index);
  const parentIndex = QuestionnaireTemplateStore.useStoreState((s) => s.getElementIndex(id).parentIndex);

  const num = parentIndex >= 0 ? `QUESTION ${parentIndex + 1}.${index + 1}` : `QUESTION ${index + 1}`;
  return <Text fontSize="sm">{num}</Text>;
});
